export var CLINIC_NAME_OR_ROOM_NAME_REGEX = /^[A-Za-z0-9.'&()/-](?:[A-Za-z0-9.'&()/\s-]*[A-Za-z0-9.'&()/-])?$/;
export var CLINIC_LINK_OR_ROOM_LINK_REGEX = /^[A-Za-z0-9]+$/;
